window.Bugsnag = {
  // `errorMessage` could be any human readable string, like
  //   "Booking is not created". All reports will be grouped
  //   by this message, so make sure it includes enough context
  //   to be unique.
  //
  // `options.severity` (optional, "error" by default) could be
  //   "error", "warning" or "info".
  //
  // `options.clientParams` (optional) could be any JSON valid payload.
  //
  // Examples:
  //
  //   Simple error message:
  //     Bugsnag.notify("Guest price missing")
  //
  //   Error with severity and clientParams:
  //     Bugsnag.notify("Booking validation failed", {
  //       severity: "warning",
  //       clientParams: {
  //         guestName: "John Doe",
  //         roomId: 123
  //       }
  //     })
  LARGE_PRIME: 1000000007,

  // Simple hash to sign error messages. Keep in sync with
  // front/app/controllers/front/bugsnag_client_reports_controller.rb
  _sign(str) {
    let h = 0
    for (let i = 0; i < str.length; i++) {
      h = (h * 31 + str.charCodeAt(i)) % this.LARGE_PRIME
    }
    return h
  },

  notify(errorMessage, options = {}) {
    const message = String(errorMessage)
    return RailsRequest.post("/bugsnag-client-reports", {
      body: {
        token: String(this._sign(message)),
        error_message: message,
        href: window.location.href,
        severity: options.severity || "error",
        client_params: options.clientParams,
        failed_request_id: options.failedRequestId || undefined,
        device: {
          time: new Date().toISOString(),
          locale:
            navigator.browserLanguage ||
            navigator.systemLanguage ||
            navigator.userLanguage ||
            navigator.language,
          userAgent: navigator.userAgent,
        },
      },
    })
  },
}
